import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const CircleDashedIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 20.0001C16.4183 20.0001 20.0001 16.4183 20.0001 12C20.0001 7.58165 16.4183 3.99988 12 3.99988C7.58165 3.99988 3.99988 7.58165 3.99988 12C3.99988 16.4183 7.58165 20.0001 12 20.0001Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export default CircleDashedIcon;